import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";
// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import StoreMallDirectory from "@mui/icons-material/StoreMallDirectory";

// core components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";


import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, PopUpResult, OpcionSiNo, OpcionTiposInstalacionReserva, OpcionesNominaciones, DriversPasarela, TiposVisualizacionInstalaciones, TiposGraficoInstalaciones } from "../othelloConstantes.jsx";
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloEdit  from '../componentsothello/OthelloEdit.jsx';
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import ImageUpload from "../components/ImageUpload.jsx";
import OthelloTimer from "../componentsothello/OthelloTimer.jsx";

import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloCheckBox from "../componentsothello/OthelloCheckBox.jsx";
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";


export default function InstalacionReservas({ ...props }) {
    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [data, setdata] = React.useState(null);

    const [alert, setalert] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const [opcnominaciones, setopcnominaciones] = useState(null);

    const navigate = useNavigate();

    const location = useLocation();

    React.useEffect(() => {

        setLoading(false);
        getDataPage();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = () => {

        fetch('api/Data/GetInstalacionesReserva')
            .then(response => response.json())
            .then(data => {
                setdata(data);
            });
    }

    const getDataVacia = () => {

        fetch('api/Data/GetInstalacionReservaVacia')
            .then(response => response.json())
            .then(data => {
                setdataeditando(data);
                setopcnominaciones(data.opcionesNominacion);
                setstatePage(DataStatePage.dsInsert);

            }).catch(error => {
                setdataeditando(null);
                setopcnominaciones("");
            });;
    }

    const grabarDataPage = (event) => {

        //Altero el valor que tiene el input de dias visualizando
        try {
            //refs.form[2].value = opcnominaciones;
        }
        catch { }

        let formulario = document.getElementById('forminstalacion');
        let formData = new FormData(formulario);

        fetch('api/Data/GrabarInstalacionReserva', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {


            if (indexeditando == -1) {

                var array = [...data];
                array.push(res);
                setdata(array);
            }
            else {
                var array = [...data];
                array[indexeditando] = res;
                setdata(array);
            }

            setstatePage(DataStatePage.dsSearch);
            setalert(PopUpResult.OK);
            
            setdataeditando(null);
            setindexeditando(null);            

        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPage = () => {    
        getDataVacia();
        setindexeditando(-1);
        setopcnominaciones("");
    }


    const buscarDataPage = () => {
        setdataeditando(null);
        setindexeditando(null);
        setstatePage(DataStatePage.dsSearch);        
    }

    const cancelarDataPage = () => {
        setdataeditando(null);
        setindexeditando(null);
        setopcnominaciones("");
        setstatePage(DataStatePage.dsSearch);
    }

    const deshacerDataPage = () => {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditando == -1)
            setstatePage(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        else {

            //Inicializo a los datos que tenia cuando se puso a editar 
            if (dataeditando != null)
                setopcnominaciones(dataeditando.opcionesNominacion);

            //forceUpdate()
        }
    }

    //METODO SOBRE EL GRID    
    const editGridDataPage =(valor, index) => {
        setdataeditando(valor);
        setindexeditando(index);
        setopcnominaciones(valor.opcionesNominacion == null || valor.opcionesNominacion == undefined ? "" : valor.opcionesNominacion);
        setstatePage(DataStatePage.dsEdit);       
    }

    const deleteGridDataPage = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Instalacion);

            fetch('api/Data/EliminarInstalacionReserva', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditando(valor);
                    setindexeditando(index);


                    if (data != null) {
                        var array = [...data]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdata(array);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const onClosePopUpResult = () => {
        setalert("");
    }

    const onChangeOpcionNominacionCheckBox = (id, valor) => {

        //Si tenemo valor editando
        if (dataeditando != null && opcnominaciones != null)
        {
            let nominaciones = opcnominaciones;

            //Si me dice que se ha seleccionado el check
            if (valor) {

                //Si no esta dentro de los dias a visualizar
                if (nominaciones.indexOf(id) < 0)
                {
                    nominaciones = nominaciones + id;
                }
            }
            //sino, es que debemos eliminarlo
            else {
                nominaciones = nominaciones.replace(id, "");
            }

            setopcnominaciones(nominaciones);
        }
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    function renderSearch(datos) {

        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Instalacion", "Codigo", "Descripcion"];

        let valoreshow = ["id_Instalacion", "codigo", "descripcion"];

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} onEdit={editGridDataPage} onDelete={deleteGridDataPage} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEdit(Instalacion)
    {
        if (Instalacion != null) {
            let Nombre = Instalacion != null && Instalacion.id_Instalacion > 0 ? "Editar " + Instalacion.codigo : "Nuevo Instalacion";

            return (<OthelloTituloPanelData icon="store_mall_directory" titulo={Nombre} margentop={4}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <Grid container>
                        <Grid item xs={12} >
                            <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} onGrabar={grabarDataPage} onCancel={cancelarDataPage} onDeshacer={deshacerDataPage} />
                        </Grid>
                    </Grid>
                    <form id="forminstalacion" >
                        <Grid container>
                            <input id="Id_Oficina" name="Id_Oficina" type="hidden" value={Instalacion.id_Oficina} />
                            <input id="Id_Instalacion" name="Id_Instalacion" type="hidden" value={Instalacion.id_Instalacion} />
                            <input id="OpcionesNominacion" name="OpcionesNominacion" type="hidden" value={opcnominaciones} />
                            <Grid item xs={4} sm={2}>
                                <OthelloEdit label="Codigo" fieldname="Codigo" currentvalue={Instalacion.codigo} />
                            </Grid>
                            <Grid item xs={4} sm={4}>
                                <OthelloEdit label="Descripcion" fieldname="Descripcion" currentvalue={Instalacion.descripcion} />
                            </Grid>
                            <Grid item xs={4} sm={2} >
                                <OthelloComboBox label='Tipo' fieldname="Tipo" items={OpcionTiposInstalacionReserva} currentvalue={Instalacion.tipo} />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <OthelloTimer label="Desde" fieldname="Desde" currentvalue={Instalacion.desde} />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <OthelloTimer label="Abierto" fieldname="Abierto" currentvalue={Instalacion.abierto} />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <OthelloComboBox label='Activo' fieldname="Activo" items={OpcionSiNo} currentvalue={Instalacion.activo} />
                            </Grid>
                            <Grid item xs={4} sm={2} >
                                <OthelloComboBox label='Visualizacion (ModoPosiciones NoDispo)' fieldname="TipoVisualizacion" items={TiposVisualizacionInstalaciones} currentvalue={Instalacion.tipoVisualizacion} />
                            </Grid>
                            <Grid item xs={4} sm={2} >
                                <OthelloComboBox label='Tipo Grafico' fieldname="TipoGrafico" items={TiposGraficoInstalaciones} currentvalue={Instalacion.tipoGrafico} />
                            </Grid>
                            <Grid item xs={4} sm={1}>
                                <OthelloEdit label="Width Grafico" fieldname="WidthGrafico" currentvalue={Instalacion.widthGrafico} />
                            </Grid>
                            <Grid item xs={4} sm={1}>
                                <OthelloEdit label="Height Grafico" fieldname="HeightGrafico" currentvalue={Instalacion.heightGrafico} />
                            </Grid>
                            <Grid item xs={4} sm={1}>
                                <OthelloEdit label="Width Img.Grafico" fieldname="WidthImgGrafico" currentvalue={Instalacion.widthImgGrafico} />
                            </Grid>
                            <Grid item xs={4} sm={1}>
                                <OthelloEdit label="Height Img.Grafico" fieldname="HeightImgGrafico" currentvalue={Instalacion.heightImgGrafico} />
                            </Grid>
                            <Grid item xs={4} sm={1}>
                                <OthelloEdit label="Dias Antelacion" fieldname="DiasAntelacion" currentvalue={Instalacion.diasAntelacion} />
                            </Grid>
                            <Grid item xs={4} sm={1}>
                                <OthelloEdit label="Tramos Dia" fieldname="TramosDia" currentvalue={Instalacion.tramosDia} />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <OthelloEdit label="Mins Cancelar Sin Pago" fieldname="minutosCancelar" currentvalue={Instalacion.minutosCancelar} />
                            </Grid>
                            <Grid item xs={4} sm={2} lg={1}>
                                <OthelloEdit label="Latitud" fieldname="latStringAux" currentvalue={Instalacion.lat} />
                            </Grid>
                            <Grid item xs={4} sm={2} lg={1}>
                                <OthelloEdit label="Longitud" fieldname="lonStringAux" currentvalue={Instalacion.lon} />
                            </Grid>
                            <Grid item xs={12} sm={4} lg={4}>
                                <OthelloEdit label="Direccion" fieldname="Direccion" currentvalue={Instalacion.direccion} />
                            </Grid>
                            <Grid item xs={4} sm={3} lg={1} >
                                <OthelloComboBox label='Obligatorio Todos Datos Contacto' fieldname="obligatorioTodosDatosContacto" items={OpcionSiNo} currentvalue={Instalacion.obligatorioTodosDatosContacto} />
                            </Grid>                           
                        </Grid>
                        <Grid container>
                            <Grid item xs={4} sm={2} lg={2}>
                                <OthelloEdit label="Literal Campo NumSocio" fieldname="literalCampoNumSocio" currentvalue={Instalacion.literalCampoNumSocio} />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <OthelloComboBox label='Activo NumSocio' fieldname="ActivoNumSocio" items={OpcionSiNo} currentvalue={Instalacion.activoNumSocio} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <OthelloEdit label="Texto NumSocio" fieldname="TextoNumSocio" currentvalue={Instalacion.textoNumSocio} rows={1} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <OthelloEdit label="Info. NumSocio" fieldname="InfoNumSocio" currentvalue={Instalacion.infoNumSocio} rows={1} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={2}>
                                <OthelloComboBox label='Activa Autorizaciones' fieldname="ActivaAutorizaciones" items={OpcionSiNo} currentvalue={Instalacion.activaAutorizaciones} />
                            </Grid>
                            <Grid item xs={12} sm={10}>
                                <OthelloEdit label="Texto Autorizaciones" fieldname="TextoAutorizaciones" currentvalue={Instalacion.textoAutorizaciones} rows={1} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4} sm={3} lg={1} >
                                <OthelloComboBox label='Nominar Pax' fieldname="nominarPax" items={OpcionSiNo} currentvalue={Instalacion.nominarPax} />
                            </Grid>
                            <Grid item xs={4} sm={3} lg={1} >
                                <OthelloComboBox label='Obligatorio Nominar Todas' fieldname="obligatorioNominarTodasPax" items={OpcionSiNo} currentvalue={Instalacion.obligatorioNominarTodasPax} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Nombre" fieldname={OpcionesNominaciones.Nombre} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Nombre) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Apellidos" fieldname={OpcionesNominaciones.Apellidos} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Apellidos) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={3} lg={1} >
                                <OthelloCheckBox label="DNI" fieldname={OpcionesNominaciones.DNI} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.DNI) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Sexo" fieldname={OpcionesNominaciones.Sexo} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Sexo) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Edad" fieldname={OpcionesNominaciones.Edad} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Edad) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Fecha Nacimiento" fieldname={OpcionesNominaciones.FechaNacimiento} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.FechaNacimiento) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Telefono" fieldname={OpcionesNominaciones.Telefono} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Telefono) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Email" fieldname={OpcionesNominaciones.Email} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Email) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Club" fieldname={OpcionesNominaciones.Club} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Club) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Direccion" fieldname={OpcionesNominaciones.Direccion} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Direccion) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="C.Postal" fieldname={OpcionesNominaciones.CodigoPostal} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.CodigoPostal) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={4} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Procedencia" fieldname={OpcionesNominaciones.Procedencia} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Procedencia) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Talla" fieldname={OpcionesNominaciones.Talla} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Talla) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={2}>
                                <OthelloCheckBox label="Nº Registro Sanitario" fieldname={OpcionesNominaciones.NumRegistroSanitario} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.NumRegistroSanitario) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>                                                      
                            <Grid item xs={12} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Sabe Nadar" fieldname={OpcionesNominaciones.SabeNadar} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.SabeNadar) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Madrugadores" fieldname={OpcionesNominaciones.Madrugadores} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Madrugadores) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={1}>
                                <OthelloCheckBox label="Curso" fieldname={OpcionesNominaciones.Curso} checked={opcnominaciones != null && opcnominaciones.indexOf(OpcionesNominaciones.Curso) >= 0} onChange={onChangeOpcionNominacionCheckBox} />
                            </Grid>                           
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={12}>
                                <OthelloEdit label="Informacion de Uso" fieldname="InfoUso" currentvalue={Instalacion.infoUso} rows="2" />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={12}>
                                <OthelloEdit label="Otra Informacion" fieldname="DatosAdicionales" currentvalue={Instalacion.datosAdicionales} rows={2} />
                            </Grid>
                        </Grid>
                        <Grid container>
                           
                            <Grid item xs={4} sm={2}>
                                <OthelloComboBox label='Activada Pasarela' fieldname="ActivaPasarela" items={OpcionSiNo} currentvalue={Instalacion.activaPasarela} />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <OthelloComboBox label='Pasarela' fieldname="ID_DriverPasarela" items={DriversPasarela} currentvalue={Instalacion.iD_DriverPasarela} />
                            </Grid>
                            <Grid item xs={4} sm={4} >
                                <OthelloComboBox label='Con Pago Contado' fieldname="PagoContadoReservas" items={OpcionSiNo} currentvalue={Instalacion.pagoContadoReservas} />
                            </Grid>
                            <Grid item xs={4} sm={2}>
                                <OthelloComboBox label='Activada Cerradura' fieldname="ActivaCerradura" items={OpcionSiNo} currentvalue={Instalacion.activaCerradura} />
                            </Grid>
                            <Grid item xs={12} sm={1} lg={1}>
                                <OthelloEdit label="ID Cerradura" fieldname="ID_Cerradura" currentvalue={Instalacion.iD_Cerradura} />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container>
                            <Grid item xs={12} sm={2}>
                                <legend>Imagen</legend>
                                <ImageUpload
                                    id="Image" name="Image"
                                    imageUrl={Instalacion.image}
                                    addButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    changeButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    removeButtonProps={{
                                        color: "danger",
                                        round: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <legend>Imagen Grafico</legend>
                                <ImageUpload
                                    id="ImageGrafico" name="ImageGrafico"
                                    imageUrl={Instalacion.imageGrafico}
                                    addButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    changeButtonProps={{
                                        color: "rose",
                                        round: true
                                    }}
                                    removeButtonProps={{
                                        color: "danger",
                                        round: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    let busqueda = loading ? <p><CircularProgress color="secondary" /></p> : renderSearch(data)

    let edicion = statePage == DataStatePage.dsEdit || statePage == DataStatePage.dsInsert ? renderInsertEdit(dataeditando) : "";

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                {edicion}
            </Grid>
            <Grid container>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePage} onNuevo={nuevoDataPage} forzarnuevo={true} />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData tituloliteral="_instalacionesreservas" margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {busqueda}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>
            </Grid>            
        </Grid>
    );
}

